import { useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  Tooltip,
  Typography,
  IconButton,
} from "@mui/material";
import { useSelector } from "react-redux";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from "react";
import { useDispatch } from "react-redux";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import RoleandAccess from "../RoleandAccess/RoleandAccess";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import { validateEmailHelper } from "../../../SignIn/helper/SigninHelper";
import { checkPayrollAccess, getUserData } from "../../../Base/helper/baseFunctions";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";
import { GetUserWorkLocationHelper, UpdateUserStatusHelper } from "../../helper/EmployeeHelper";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import MUICustomToggle from "../../../Base/views/MUICustomToggle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Popup from "../../../Base/views/Popup";
import CreateuserPopup from "../../helper/CreateuserPopup";

const MyEmployeeAccess= ({openPopup, setOpenPopup}) => {
    const dispatch = useDispatch();
    const user = getUserData()
    const [currentMode, setCurrentMode] = useState("grid");
    const [currentData, setCurrentData] = useState("")
    const { employees_options, isEmployeeLoading } = useSelector(
        (state) => state?.EmployeeReducer.EmployeesReducer
      );
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [showResetConfirm, setShowResetConfirm] = useState(false);
    const [showDisableConfirm, setShowDisableConfirm] = useState(false);
    const [filters, setFilters] = useState({
              ats_work_location_id: []
      });
    const [isActive, setIsActive] = useState(true);
    const [userData, setUserData] = useState([]);    
    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
    const leaveAccess = atsModuleData?.find((item) => item.module_name === "Leave");

  const fetchData = () => {
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    dispatch(GetEmployeesAction({ is_active: true,
        ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
      }));
  }
  useEffect(() => {
    fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[filters])
  useEffect(() => {
    const empUser = (employees_options || [])?.filter((item) => item?.emp_users);
    const Users = empUser?.filter(el => el?.emp_users_status === isActive);
    setUserData(Users || [])
  },[isActive, employees_options]);
  const hanldeEdit = (data) => {
    isActive && setCurrentMode("edit");
    setCurrentData(data);
  };
  const handleClick = (event, data) => {
    setCurrentData(data)
    setAnchorEl(event.currentTarget);
  };
  const handleResetPassword = () => {
    validateEmailHelper({ domain: user?.domain, email: currentData?.office_email, message: "Reset Link has been sent to the Email" })
    setShowResetConfirm(false);
  } 
  const handleDisableLogin = () => {
    UpdateUserStatusHelper({emp_user_fk: currentData?.emp_users, status: !isActive}).then(res => {
      if (res?.data?.statuscode === 200) {
        fetchData();
      }
      handleDisablePopupClose();
    })
  } 
  const handleDisablePopupClose = () => {
    setCurrentData("");
    setShowDisableConfirm(false)
  }    
  const [worklocationData, setWorklocationData] = useState({
        load: true,
        values: [],
  });
  const handleWorkLoacation = () => {
    GetUserWorkLocationHelper().then(res => {
      if(res?.data?.statuscode === 200){
        setWorklocationData({ load: false, values: res?.data?.data || [] })
      } else {
        setWorklocationData({ load: false, values: [] })
      }
    })
  }
  const handleFilterChange = (event, value) => {
      if (["ats_work_location_id"].includes(event)) {
      if (value) {
          setFilters({ ...filters, [event]: value });
      } else {
          setFilters({ ...filters, [event]: "" });
      }
    }
  }

  return (
      <Box sx={{ maxHeight: currentMode === "grid" ? "calc(100vh - 75px)" : "calc(100vh - 118px)", overflowY: "auto" }}>

      {
      currentMode === "grid" ?
      <>
      <MaterialTable
        onRowClick={(event, rowData) => hanldeEdit(rowData)}
        isLoading={isEmployeeLoading}
          columns={[
            {
              title: "Name",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "name",
              grouping: false,
            },
            {
              title: "Email",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "office_email",
              grouping: false,
            },
            {
              title: "Designation",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "designation",
            },
            {
                title: "Work Location",
                cellStyle: { padding: "10px 10px 10px 13px"},
                field: "work_location",
                grouping: false,
                render: (rowData) => {
                    return rowData?.work_location || "N/A";
                }
            },
            {
              title: "User Type",
              cellStyle: { padding: "5px 10px 5px 15px" },
              field: "core_hr_user_type",
            },
            {
              title: "Core HR", field: "enable_corehr",
              headerStyle:{ textAlign:"center"}, cellStyle: { padding: "5px 10px 5px 13px", textAlign:"center" },
              sorting: false,
              render: rowData => {
                  return rowData.enable_corehr ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                      : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
              }
          },
          {
              title: "LMS", field: "enable_lms",
              headerStyle:{ textAlign:"center"}, cellStyle: { padding: "5px 10px 5px 13px", textAlign:"center" },
              sorting: false,
              render: rowData => {
                  return rowData.enable_lms ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                      : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
              },
              hidden: user?.f_country_code !== "IND" || !leaveAccess
          },
          {
              title: "LMS Executive", field: "enable_lms_executive",
              headerStyle:{ textAlign:"center"}, cellStyle: { padding: "5px 10px 5px 13px", textAlign:"center" },
              sorting: false,
              render: rowData => {
                  return rowData.enable_lms_executive ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                      : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
              },
              hidden: user?.f_country_code !== "IND" || !leaveAccess
          },
          {
            title: "ATS", field: "enable_ats", 
            hidden: !user?.enable_ats,
            headerStyle:{ padding:"5px 10px 5px 10px", textAlign:"center"}, 
            cellStyle: { padding: "5px 10px 5px 13px",textAlign:"center" },
            sorting: false,
            render: rowData => {
                return rowData.enable_ats ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                    : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
            }
          },
          {
            title: "Visitor Management", field: "enable_visitor_management", 
            hidden: !user?.workspace_visitor_management_flag,
            headerStyle:{ padding:"5px 10px 5px 10px", textAlign:"center"}, 
            cellStyle: { padding: "5px 10px 5px 13px",textAlign:"center" },
            sorting: false,
            render: rowData => {
                return rowData.enable_visitor_management ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                    : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
            }
          },
          {
            title: "Expense Management", field: "enable_expense_executive", 
            hidden: !user?.workspace_expense_flag,
            headerStyle:{ padding:"5px 10px 5px 10px", textAlign:"center"}, 
            cellStyle: { padding: "5px 10px 5px 13px",textAlign:"center" },
            sorting: false,
            render: rowData => {
                return rowData.enable_expense_executive ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                    : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
            }
          },
          {
            title: "Payroll Executive Access",
            hidden: !checkPayrollAccess(),
            headerStyle:{ padding:"5px 10px 5px 10px", textAlign:"center"}, 
            cellStyle: { padding: "5px 10px 5px 13px",textAlign:"center" },
            sorting: false,
            render: (rowData) => {
              const isExecutiveAccessEnabled =
                rowData.enable_payroll_executive || rowData.enable_finance_executive;
          
                return isExecutiveAccessEnabled ? (
                  <Tooltip
                    title={
                      <Box sx={{ maxWidth: "120px", whiteSpace: "normal" }}>
                        { rowData.enable_payroll_executive && <div>Payroll Executive</div> }
                        { rowData.enable_finance_executive && <div>Finance Executive</div>}
                      </Box>
                    }
                    arrow
                  >
                    <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                  </Tooltip>
                ) : (
                  <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
                );
            }
            
          },
          {
            title: "Actions",
            field: "action",
            width:"8%",
            grouping: false,
            sorting: false,
            headerStyle: {  textAlign: "center" }, 
            cellStyle: { padding: "10px", textAlign: "center" },
            render: (rowData) => (
              <Tooltip title="Actions">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClick(e, rowData);
                  }}
                  sx={{
                    padding: "0px",width: "30px", height: "30px", cursor: "pointer"
                  }}
                >
                  <MoreVertIcon fontSize="small" sx={{ fontWeight: "bold" }} />
                </IconButton>
              </Tooltip>
            ),
          }
          ]}
          data={userData || []}
          options={{
            maxBodyHeight: "calc(100vh - 255px)",
            minBodyHeight: "calc(100vh - 255px)",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
            },
            headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold", fontSize:"12px" },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: true,
          }}
          components={{
             Toolbar: (props) => (
                <Box
                    sx={{
                      display: "flex",
                      flexDirection: {xs: "column", sm: "row"},
                      alignItems: "center",
                      backgroundColor: "#f3edfd",
                      width: "100%",
                    }}
                  >
                    <Box
                        sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding:  {xs: "0px 0px 0px 5px", sm: "0px 0px 0px 20px"},
                        flexGrow: 1,
                        minHeight: "40px !important",
                        }}
                    >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="h6">
                            {isActive ? "Active Employees" : "Inactive Employees"}
                        </Typography>

                        <Tooltip
                            arrow
                            title={
                                isActive
                                    ? "Active employees have login access enabled."
                                    : "Inactive employees have login access disabled."
                            }
                        >
                            <InfoOutlinedIcon
                                sx={{
                                    fontSize: 18,
                                    color: "text.secondary",
                                    cursor: "pointer",
                                }}
                            />
                        </Tooltip>
                    </Box>
                    <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 1}}>
                        <SelectableMultiSelect
                            multiple
                            label="Work Location"
                            placeholder="Select Location"
                            value={filters?.ats_work_location_id}
                            loading={handleWorkLoacation}
                            fieldLabel="work_location_name"
                            name="ats_work_location_id"
                            size="small"
                            onChangeEvent={handleFilterChange}
                            data={worklocationData}
                            menuHeight={150} // optional
                        />
                        
                    </Box> 
                    </Box>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        minHeight: "40px !important",
                        pr: 1
                        }}>
                      <Box
                          sx={{
                              "& .MuiToolbar-root": {
                              padding: "14px 10px 10px 16px !important",
                              margin: "0 !important",
                              minHeight: "40px !important",
                              },
                              "& .MuiFormControl-root": {
                              margin: "0 !important",
                              },
                              "& .MuiInputBase-root": {
                              marginLeft: "-40px !important",
                              }
                          }}
                          >
                              <MTableToolbar {...props} />
                      </Box>
                      <MUICustomToggle
                          value={isActive}
                          onChange={setIsActive}
                          leftText="Active"
                          rightText="Inactive"
                          width={150}
                          height={32}
                      />
                    </Box>
                </Box>
            ),
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} dark={false}/>,
          }}

          title=""
        />
          <Menu
            id="more-options-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              'aria-labelledby': 'more-options-button',
            }}
            >
                {isActive && (
                  <MenuItem onClick={() => { setShowResetConfirm(true); setAnchorEl(null); }}>
                    <ListItemIcon>
                        <LockResetIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Reset Password</ListItemText>
                </MenuItem>)}
                <MenuItem onClick={() => { setShowDisableConfirm(true); setAnchorEl(null); }}>
                    <ListItemIcon>
                        {isActive ? (
                            <NoAccountsIcon fontSize="small" />
                          ) : (
                            <HowToRegIcon fontSize="small" />
                        )}
                    </ListItemIcon>
                    <ListItemText>{isActive ? "Disable Login" : "Enable Login"}</ListItemText>
                </MenuItem>
          </Menu>

            <ConfirmationDialog
                title={`Reset Password for ${currentData?.name}`}
                content="Are you sure you want to sent reset password email ?"
                openDialog={showResetConfirm}
                closeDialog={setShowResetConfirm}
                popupTitle="Users"
                CancelButtonText="Cancel"
                OkButtonText="Send Email"
                onCancel={() => setShowResetConfirm(false)}
                onSubmit={() => handleResetPassword()}
            />
            {/*  Disable user login confirmation  */}
            <ConfirmationDialog
                title={`${isActive ? "Disable" : "Enable"} Login  for ${currentData?.name}`}
                content={`Are you sure you want to ${isActive ? "disable" : "enable"} login access ?`}
                openDialog={showDisableConfirm}
                closeDialog={handleDisablePopupClose}
                CancelButtonText="Cancel"
                OkButtonText="Yes"
                onCancel={handleDisablePopupClose}
                onSubmit={() => handleDisableLogin()}
            />
        </> : <>
        <RoleandAccess setCurrentMode={setCurrentMode} currentMode={currentMode} OnboardingEmpData={currentData} />
        </>
      }
       <Popup
            title={"Create User"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            maxWidth="sm"
            fullWidth={true}
        >
          <CreateuserPopup onClose={() => setOpenPopup(false)} fetchData={fetchData}/>
            
        </Popup>
      </Box>
  );
};

export default MyEmployeeAccess;